export const scrollToTop = (scrollPage) => {
    scrollPage?.current?.scrollIntoView({ behavior: "smooth"});
}